interface CopyProps {
  value?: string; // 복사할 문자열
  className?: string;
  setToastMsg?: (msg: string) => void; // 토스트 메시지 설정 함수
  toastMsg?: string;
}
export default function Copy({ value, className = 'ml-2 h-8 w-8', setToastMsg, toastMsg }: CopyProps) {
  const handleCopy = async () => {
    if (!value) {
      return;
    }
    try {
      await navigator.clipboard.writeText(value);
      if (setToastMsg) {
        setToastMsg(toastMsg!);
      }
    } catch (err) {
      console.error('복사 실패:', err);
      alert('복사에 실패했습니다. 브라우저 설정을 확인해주세요.');
    }
  };
  return (
    <svg onClick={handleCopy} className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
      />
    </svg>
  );
}
